enum actionTypes {
  FETCH_SKI_SCHOOLS = "FETCH_SKI_SCHOOLS",
  FETCH_SKI_SCHOOL_TYPES = "FETCH_SKI_SCHOOL_TYPES",
}

export default actionTypes;
